var FormatterHelper = /** @class */ (function () {
    function FormatterHelper() {
    }
    FormatterHelper.getformattedValueUsingCurrencyId = function (value, currencyId, minimumFractionDigits) {
        var culture = "";
        return FormatterHelper.getformattedValue(value, culture, minimumFractionDigits);
    };
    FormatterHelper.getformattedValue = function (value, culture, minimumFractionDigits) {
        culture = culture ? culture : window.navigator.language;
        return value ? value.toLocaleString(culture, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: minimumFractionDigits }) : (0).toLocaleString(culture, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: minimumFractionDigits });
    };
    FormatterHelper.getCurrencyValueUsingCurrencyId = function (value, currencyId, minimumFractionDigits) {
        var culture = "";
        var symbol = "";
        return FormatterHelper.getCurrencyValue(value, culture, minimumFractionDigits, symbol);
    };
    FormatterHelper.getCurrencyValue = function (value, culture, minimumFractionDigits, currencySymbol) {
        culture = culture ? culture : window.navigator.language;
        var valueFormatted = value && value != null
            ? value.toLocaleString(culture, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: minimumFractionDigits })
            : (0).toLocaleString(culture, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: minimumFractionDigits });
        var valueWithCurrency = currencySymbol + valueFormatted;
        return valueWithCurrency;
    };
    FormatterHelper.getFormattedNegativeWithBrackets = function (value, culture, minimumFractionDigits) {
        var formattedValue = value >= 0 ? FormatterHelper.getformattedValue(value, culture, minimumFractionDigits) :
            "(" + FormatterHelper.getformattedValue(Math.abs(value), culture, minimumFractionDigits) + ")";
        return formattedValue;
    };
    return FormatterHelper;
}());
export { FormatterHelper };
